import { render, staticRenderFns } from "./qyClassManAdd.vue?vue&type=template&id=80bb24e0&scoped=true"
import script from "./qyClassManAdd.vue?vue&type=script&lang=js"
export * from "./qyClassManAdd.vue?vue&type=script&lang=js"
import style0 from "./qyClassManAdd.vue?vue&type=style&index=0&id=80bb24e0&prod&lang=scss"
import style1 from "./qyClassManAdd.vue?vue&type=style&index=1&id=80bb24e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bb24e0",
  null
  
)

export default component.exports